import gql from 'graphql-tag'

export const changePasswordMutation = gql`
  mutation changeUserPassword($id: ID!, $oldPassword: String!, $password: String!, $confirmPassword: String!) {
    changeUserPassword(id: $id, oldPassword: $oldPassword, password: $password, confirmPassword: $confirmPassword){
      status
    }
  }
`
